import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Action } from "@ngrx/store";
import { ActionWithPayload, batchActions } from "@obg/ngrx-utils";
import { AppError, AUTH_ACTION_TYPE, MessageScopeType, MessageService, MessageType } from "@obg/ngx.core";
import { merge, Observable, of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { PERSONAL_DATA_ACTION_TYPE, PersonalDataAction } from "./personal-data.action";
import { PERSONAL_DATA_MESSAGE_CODES } from "./personal-data.const";
import { SarRequestDatasetsResponse, SarSubjectId } from "./personal-data.model";
import { PersonalDataService } from "./personal-data.service";
/**
 * @deprecated - [fabric-deprecated] - Use PersonalDataService from app-account mfe instead
 */
@Injectable()
export class PersonalDataEffect {
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.PersonalDataRequestSarData) instead
	 */
	getRequests$: Observable<Action> = createEffect(() =>
		this.actions$.pipe(
			ofType(PERSONAL_DATA_ACTION_TYPE.getRequests),
			map((x: ActionWithPayload<string[]>) => x.payload),
			switchMap(() =>
				this.service.getRequests().pipe(
					map((response) => PersonalDataAction.getRequestsSuccess(response)),
					catchError((response: AppError) => of(PersonalDataAction.getRequestsFail(response)))
				)
			)
		)
	);
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.PersonalDataRequestDatasets) instead
	 */
	requestDataSets$: Observable<Action> = createEffect(() =>
		this.actions$.pipe(
			ofType(PERSONAL_DATA_ACTION_TYPE.requestDataSets),
			map((x: ActionWithPayload<string[]>) => x.payload),
			switchMap((dataSets: SarSubjectId[]) =>
				this.service.requestDataSets(dataSets).pipe(
					map((response: SarRequestDatasetsResponse) =>
						batchActions(
							PersonalDataAction.requestDataSetsSuccess(response),
							PersonalDataAction.getRequests()
						)
					),
					catchError((response: AppError) => of(PersonalDataAction.requestDataSetsFail(response)))
				)
			)
		)
	);
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.PersonalDataRequestDatasets) instead
	 */
	sendDownloadRequest$: Observable<Action> = createEffect(() =>
		this.actions$.pipe(
			ofType(PERSONAL_DATA_ACTION_TYPE.sendDownloadRequest),
			map((x: ActionWithPayload<number>) => x.payload),
			switchMap((id: number) =>
				this.service.sendDownloadRequest(id).pipe(
					map(() => PersonalDataAction.sendDownloadRequestSuccess()),
					catchError((response: AppError) => of(PersonalDataAction.sendDownloadRequestFail(response)))
				)
			)
		)
	);

	clear$ = createEffect(() =>
		this.actions$.pipe(
			ofType(AUTH_ACTION_TYPE.sessionEnd),
			map(() => PersonalDataAction.clear())
		)
	);

	initMessages$ = createEffect(() =>
		merge(
			this.messageService.map$({
				[PERSONAL_DATA_ACTION_TYPE.requestDataSetsFail]: {
					context: PERSONAL_DATA_ACTION_TYPE.requestDataSetsFail,
					scope: MessageScopeType.Local,
					type: MessageType.Error,
					messageCode: PERSONAL_DATA_MESSAGE_CODES.genericError,
				},
			}),
			this.messageService.map$({
				[PERSONAL_DATA_ACTION_TYPE.requestDataSetsSuccess]: {
					context: PERSONAL_DATA_ACTION_TYPE.requestDataSetsSuccess,
					scope: MessageScopeType.Local,
					type: MessageType.Success,
					messageCode: PERSONAL_DATA_MESSAGE_CODES.requestDataSetsSuccess,
				},
			})
		)
	);

	constructor(
		private actions$: Actions,
		private service: PersonalDataService,
		private messageService: MessageService
	) {}
}
